import React from "react";
import { components } from "react-select";
import Select from "react-select";
import { FormControl, FormHelperText, InputLabel } from "@mui/material";
import PropTypes from "prop-types";
import classNames from "classnames";
import "./style.css";

const NoOptionsMessage = (props) => {
  return (
    <components.NoOptionsMessage {...props}>
      Sin resultados
    </components.NoOptionsMessage>
  );
};

const LoadingMessage = (props) => {
  return (
    <components.LoadingMessage {...props}>
      Cargando...
    </components.LoadingMessage>
  );
};

const DropdownIndicator = () => null;
const IndicatorSeparator = () => null;

const selectStyles = {
  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
  menu: (provided) => ({ ...provided, zIndex: "9999 !important" }),
  option: (styles, { data }) => {
    return {
      ...styles,
      color: data["disabled"] ? "red" : "black",
    };
  },
  control: (base) => ({
    ...base,
    height: "30px",
    minHeight: "30px",
  }),
  indicatorsContainer: (base) => ({
    ...base,
    height: "30px",
  }),
  singleValue: (base) => ({
    ...base,
    fontSize: "13px",
  }),
  valueContainer: (base) => ({
    ...base,
    padding: "0 5px",
    height: "30px",
    minHeight: "30px",
  }),
};

const selectStyleWithError = {
  ...selectStyles,
  control: (base) => ({
    ...base,
    height: "30px",
    minHeight: "30px",
    border: "1px solid red",
    "&:hover": {
      borderColor: "red",
    },
  }),
  placeholder: (base) => ({
    ...base,
    color: "#d32f2f",
  }),
  indicatorsContainer: (base) => ({
    ...base,
    height: "30px",
    "& svg": {
      fill: "#d32f2f",
    },
  }),
};

/**
 * Select
 * @param name
 * @param placeholder
 * @param value
 * @param options
 * @param disabled
 * @param canClear
 * @param isLoading
 * @param onChange
 * @param name
 * @param placeholder
 * @param value
 * @param options
 * @param disabled
 * @param canClear
 * @param isLoading
 * @param onChange
 * @param onBlur
 * @param menuPlacement
 * @param isOpenMenu
 * @param className
 * @param readOnly
 * @param maxMenuHeight
 * @param error
 * @param helperText
 * @param label
 * @param isMulti
 */
export const CReactSelect = ({
  name,
  placeholder,
  value,
  options = [],
  disabled = false,
  canClear = true,
  isLoading = false,
  onChange,
  onBlur,
  menuPlacement,
  isOpenMenu = true,
  className,
  readOnly,
  maxMenuHeight,
  error,
  helperText,
  label,
  isMulti,
}) => {
  const customComponents = { NoOptionsMessage, LoadingMessage };
  const customComponentsReadOnly = {
    ...customComponents,
    DropdownIndicator,
    IndicatorSeparator,
  };

  return (
    <>
      <InputLabel shrink className="colorGnral-red inputLabel-CText">
        {label}
      </InputLabel>
      <FormControl variant="outlined" size="small" fullWidth>
        <Select
          isMulti={isMulti}
          styles={error ? selectStyleWithError : selectStyles}
          className={classNames("custom-select", className)}
          isSearchable={!readOnly}
          maxMenuHeight={maxMenuHeight ?? undefined}
          name={name}
          placeholder={placeholder}
          value={value}
          openMenuOnClick={isOpenMenu}
          options={options}
          getOptionLabel={(e) => e.text}
          getOptionValue={(e) => e.value}
          cacheOptions
          menuPlacement={menuPlacement}
          isLoading={isLoading}
          isDisabled={disabled}
          isClearable={canClear}
          onChange={onChange}
          onBlur={onBlur}
          components={!readOnly ? customComponents : customComponentsReadOnly}
          menuPortalTarget={document.body}
        />
        {Boolean(error || helperText) && (
          <FormHelperText style={{ color: error ? "#d32f2f" : undefined }}>
            {error || helperText}
          </FormHelperText>
        )}
      </FormControl>
    </>
  );
};
CReactSelect.propTypes = {
  name: PropTypes.string,
  placeholder: PropTypes.string.isRequired,
  value: PropTypes.object,
  label: PropTypes.string,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.number,
      value: PropTypes.number.isRequired,
      text: PropTypes.string.isRequired,
      disabled: PropTypes.string,
    })
  ),
  disabled: PropTypes.bool,
  canClear: PropTypes.bool,
  isLoading: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
};
